export const hostName = 'http://localhost:3000';
export const twitterUriShare = 'https://twitter.com/intent/tweet?url=';
export const facebookUriShare = 'https://www.facebook.com/sharer.php?u=';